export const parentQuestions = [
  {
    id: 'reading_style',
    question: "How does your child like to read?",
    options: ['With visuals', 'With audio', 'Independently', 'Other: ____']
  },
  {
    id: 'reading_time',
    question: "How long can your child focus on reading?",
    options: ['<5 minutes', '5-10 minutes', '10-20 minutes', '20+ minutes']
  },
  {
    id: 'reading_supports',
    question: "Would any of these be of support when reading?",
    options: ['Text To Speech', 'Larger fonts', 'No support', 'Unsure']
  },
  {
    id: 'reading_challenges',
    question: "Does your child experience any of the following that we should keep in mind to help them enjoy reading?",
    options: ['Attention differences (ADHD)', 'Autism (ASD)', 'Dyslexia or other reading challenges', 'Unsure']
  }
];